import PropTypes from "prop-types"
import { Avatar, ListItemAvatar, CircularProgress, ListItem, ListItemText } from "@mui/material"
import { CloudDownload } from "@mui/icons-material"
import { appendTimestamp } from "modules/server-notifications/helpers"

export default function InProgress({ success, total, createdAt }) {
  const message = success === 0
    ? "Your file download is queued"
    : "Your file is being prepared"

  return <ListItem className="inProgress">
    <ListItemAvatar>
      <Avatar>
        <CloudDownload />
      </Avatar>
    </ListItemAvatar>
    <CircularProgress
      variant="determinate"
      value={success / total * 100}
      style={{ position: "absolute" }}
    />
    <ListItemText primary={message} secondary={appendTimestamp("Security Search Results", createdAt)} />
  </ListItem>
}

InProgress.propTypes = {
  success: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  createdAt: PropTypes.string.isRequired,
}
